export default {
  domain: '{domain}',
  description1: 'Fizemos uma seleção de plugins para você que usa o <b>Plano Wordpress</b> ',
  description2: ', pois o uso de plugins depende da capacidade da memória do plano. Escolha abaixo um plugin para instalar no site '
}
